/**
 * The last whistle as the admin phone types it and reads it. Plain .ts with no screen in it, so
 * the tests can load it. The day a whistle is on is kept: a time typed on Friday for Sunday's
 * whistle stays on Sunday.
 */

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

/** "17:45" in this phone's own time, as the rest of the admin screen shows it. */
export function clockTime(ms: number): string {
  const d = new Date(ms);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/**
 * The whistle for a typed "17:30": that time on the day the whistle is already on, or today when
 * there is none (after Clear, Set puts it on today).
 */
export function whistleAt(input: string, lastWhistle: number | null, now: number): number {
  const [h, m] = input.split(":").map(Number);
  const d = new Date(lastWhistle ?? now);
  d.setHours(h ?? 0, m ?? 0, 0, 0);
  return d.getTime();
}

/** "17:45" when the whistle is today, "17:45, Sun" when it is on another day. */
export function whistleWhen(lastWhistle: number, now: number): string {
  const w = new Date(lastWhistle);
  return w.toDateString() === new Date(now).toDateString() ? clockTime(lastWhistle) : `${clockTime(lastWhistle)}, ${DAYS[w.getDay()]}`;
}

/** " That is after the last whistle (17:45)." when `end` is later than a whistle that is set, else "". */
export function afterWhistle(end: number, lastWhistle: number | null): string {
  return lastWhistle !== null && end > lastWhistle ? ` That is after the last whistle (${clockTime(lastWhistle)}).` : "";
}
